import { render, staticRenderFns } from "./PopupPlanProject.vue?vue&type=template&id=2ec1d57e&scoped=true"
import script from "./PopupPlanProject.vue?vue&type=script&lang=js"
export * from "./PopupPlanProject.vue?vue&type=script&lang=js"
import style1 from "./PopupPlanProject.vue?vue&type=style&index=1&id=2ec1d57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1d57e",
  null
  
)

export default component.exports